import PageHeader from "@/components/PageHeader";

export default function ComingSoon({ title, description }) {
  return (
    <div data-testid="coming-soon-page">
      <PageHeader
        eyebrow="Roadmap"
        title={title}
        description={description}
        testId={`coming-soon-header-${title.toLowerCase().replace(/\s+/g, "-")}`}
      />
      <div className="max-w-[1400px] mx-auto px-8 py-16">
        <div className="border border-dashed border-zinc-300 rounded-lg p-16 text-center bg-white">
          <div className="font-heading text-2xl font-bold text-zinc-900">This module is on the roadmap.</div>
          <p className="mt-3 text-sm text-zinc-500 max-w-md mx-auto">
            The schema and navigation are reserved. Ship-ready in an upcoming sprint. See the{" "}
            <a href="/app/roadmap" className="underline underline-offset-2 text-zinc-900">Architecture & Roadmap</a> tab for the full plan.
          </p>
        </div>
      </div>
    </div>
  );
}
